import { NavigationEnd } from '@angular/router';
import { PlayerLogService } from './../../../../../player/services/PlayerLog.service';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { SafePipeElements } from './../safePipe.pipe';
import { ScreenElementClass } from './../screen-element.class';
import { ICustomPropConfig } from './../../prop-editors.moudule/custom-prop-config.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { SeVideoConfig } from './se-video-config.class';
import { Observer } from 'rxjs/Observer';
import { IScreenElement } from './../screen-element.interface';
import { v4 as uuid } from 'uuid';

import {
  Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Injector, ElementRef, ChangeDetectorRef, SimpleChange, Renderer2, EventEmitter, ChangeDetectionStrategy
} from '@angular/core';
import { VgAPI } from 'videogular2/core';
import { VgControlsHidden } from 'videogular2/src/core/services/vg-controls-hidden';
import { GlobalPropertiesService } from '../../../../../core.module/services/global-properties.service';
import { Video } from '../../../../../shared/sdk';


@Component({
  selector: 'app-se-video',
  templateUrl: './se-video.component.html',
  styleUrls: ['./se-video.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
})
export class SeVideoComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {
  public sizeChangeObserver: Observer<{ size: { width: number, height: number } }> = {
    next: (x) => {

    },
    error: (err) => {

    },
    complete: () => {

    }
  };

  public ngUnsubscribe = new Subject(); // for ngUnsubscribe pattern recommended by google
  public videoFinished: EventEmitter<any> = new EventEmitter();
  public elementConfig = new SeVideoConfig(); // override value of base config;
  public vgapi: VgAPI;
  public currentTime = 0;
  public currentTimeStr = '00:00';
  public autoplay = false;
  public playerReady = false;
  public duration = 0;
  public durationStr = '00:00';
  public state = 'stopped';
  public playWhenReady = false;
  public tempVidID = uuid();

  @ViewChild('video') video;

  get volume() {
    return this.elementConfig.volume;
  }

  set volume(val) {
    if (this.vgapi) {
      this.vgapi.volume = val;
    }

    this.elementConfig.volume = val;
  }

  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    public renderer: Renderer2,
    private controlsHidden: VgControlsHidden,
    public gps: GlobalPropertiesService
  ) {

    super(sanitizer); // initilize base class
    this.elementConfig = new SeVideoConfig(); // create new config for this element type

    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected

    const autoPlayOnPlayer = this.injector.get('autoPlayOnPlayer');  // get autoPlayOnPlayerValue Value if injected
    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }

    this.autoplay = (this.gps.appGlobal.isDesignerMode && this.elementConfig.autoplayInDesigner) || !this.gps.appGlobal.isDesignerMode && autoPlayOnPlayer;

  }

  ngOnInit() {
    // this.elementConfig.sourceUrl = 'https://1031.myrapid.camera/live/1/live.m3u8';
    // this.hlsSrc = 'https://videorelay.bahlinc.com/streams/12345.m3u8';

  }

  ngAfterViewInit() {
    this.onElementReadySubject.next(this);

    // const autoPlayOnPlayer = this.injector.get('autoPlayOnPlayer');  // get autoPlayOnPlayerValue Value if injected
    // this.autoplay = (this.gps.appGlobal.isDesignerMode && this.elementConfig.autoplayInDesigner) || !this.gps.appGlobal.isDesignerMode && autoPlayOnPlayer;
    // if (this.video) { this.video.nativeElement.play(); }
  }

  // called from screen panel componenct during screen element delete
  // allows some cleanup to happen before the object is removed from the DOM, which is when onDestroy() is called
  async preDestroy() {

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();





    // kill video right way
    if (this.video) {

      const isPlaying = this.video.nativeElement.currentTime > 0 && !this.video.nativeElement.paused && !this.video.nativeElement.ended
        && this.video.nativeElement.readyState > 2;

      if (isPlaying) {
        this.video.nativeElement.pause();
      }


      this.elementConfig.sourceUrl = '';
      this.video.nativeElement.srcObject = null;
      this.autoplay = false;
      this.video.nativeElement.removeAttribute('autoplay');

      this.video.nativeElement.setAttribute('src', ''); // empty source
      this.video.nativeElement.removeAttribute('src');
      // this.changeDetectorRef.detectChanges();
      this.video.nativeElement.load(); // reset with empty source
      // this.video.nativeElement.parentNode.removeChild(this.video.nativeElement);
    }

    if (this.vgapi) {
      const media = this.vgapi.getMasterMedia();
      // media.pause();
      this.vgapi.unregisterMedia(media);
      // this.changeDetectorRef.detectChanges();

      // for (const k of Object.keys(this.vgapi)) {
      //   this.vgapi[k] = null;
      // }

      // for (const k of Object.keys(media.subscriptions)) {
      //   if (media.subscriptions[k]) {
      //    media.subscriptions[k].unsubscribe();
      //   }
      // }
      (<any>media).ref.destroy();
    }


    await new Promise(resolve => {
      let to = setTimeout(() => {
        resolve();
        to = null;
      }, 10);

    }); // pause for 10ms to let pending subscriptions play out

  }

  ngOnDestroy() {

    // this.vgapi = null;
    this.video = null;

    super.gcCleanup();



  }

  changeHook(change: SimpleChange) {

  }

  pause() {
    if (this.vgapi && this.vgapi.isPlayerReady) {

      if (this.video) {
        const isPlaying = this.video.nativeElement.currentTime > 0 && !this.video.nativeElement.paused && !this.video.nativeElement.ended
          && this.video.nativeElement.readyState > 2;

        if (isPlaying) {
          this.vgapi.pause();
        }
      }
      this.state = 'paused';
    }

    this.playWhenReady = false;
  }


  stop() {
    if (this.vgapi && this.vgapi.isPlayerReady) {
      if (this.video) {
        const isPlaying = this.video.nativeElement.currentTime > 0 && !this.video.nativeElement.paused && !this.video.nativeElement.ended
          && this.video.nativeElement.readyState > 2;

        if (isPlaying) {
          this.vgapi.seekTime(0);
          this.vgapi.pause();
          this.state = 'stopped';
        }
      }

    }

    this.playWhenReady = false;
    this.videoFinished.emit(true);
  }

  play() {
    if (this.vgapi && this.vgapi.canPlay) {
      this.vgapi.play();
      this.state = 'playing';
    } else {
      // this.logger.info(`VIDEO ELEMENT: A play command was received, but the player was not ready.  Will begin playing when ready`);
    }

    this.playWhenReady = true;
  }

  toggleMute() {
    if (this.vgapi && this.vgapi.isPlayerReady) {
      this.elementConfig.mute = !this.elementConfig.mute;

      if (this.elementConfig.mute) {
        this.vgapi.volume = 0;
      } else {
        this.vgapi.volume = this.elementConfig.volume;
      }
    }
  }


  onPlayerReady(api: VgAPI) {

    this.vgapi = api;
    if (this.vgapi && this.vgapi.getDefaultMedia()) {
      this.playerReady = true;
      const that = this;

      this.vgapi.getDefaultMedia().subscriptions.ended.takeUntil(this.ngUnsubscribe).subscribe(() => {

        if (!this.elementConfig.loop) {
          this.videoFinished.emit(true);
        }
      });

      this.vgapi.getDefaultMedia().subscriptions.canPlay.takeUntil(this.ngUnsubscribe).subscribe(playTheVideo => {
        // this.logger.info(`VIDEO ELEMENT: file: '${this.elementConfig.modelRef.OriginalFilename}' - CanPlay Ready`);
        this.controlsHidden.state(false);

        // set starting volume
        if (this.elementConfig.mute) {
          this.vgapi.volume = 0;
        } else {
          this.vgapi.volume = this.elementConfig.volume;
        }

        if (that.autoplay || that.playWhenReady) {
          this.vgapi.play();
        }
      });

      this.vgapi.getDefaultMedia().subscriptions.loadedMetadata.takeUntil(this.ngUnsubscribe).subscribe(value => {
        this.elementConfig.screenTime = this.vgapi.duration; // set the min screentime
        this.duration = null; // gc
        this.duration = this.vgapi.duration;
        this.durationStr = this.hhmmss(this.duration);

      });

      this.vgapi.getDefaultMedia().subscriptions.timeUpdate.takeUntil(this.ngUnsubscribe).subscribe(value => {
        this.currentTime = isNaN(this.vgapi.currentTime) ? 0 : Math.floor(this.vgapi.currentTime); // set the minimu screentime
        this.currentTimeStr = this.hhmmss(this.currentTime);

      });

    }

    // this.vgapi.play();

  }


  getCustomProperties() {

    const userAdjustableProps: ICustomPropConfig[] = new Array;


    const peVideo: ICustomPropConfig = {
      type: 'pe-video',
      name: 'video controls',
      propPath: 'initial',
      defaultValue: .5,
      tooltip: 'Video Controls',
      showDefaultReset: true,
      groupName: null,
      settings: {
        step: .01,
        direction: 'ltr',
        connect: [true, true],
        start: [.5],
        range: {
          min: 0,
          max: 1
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    userAdjustableProps.push(peVideo);

    return userAdjustableProps;
  }

  pad(num) {
    return ('0' + num).slice(-2);
  }
  hhmmss(secs) {
    const minutes = Math.floor(secs / 60);
    secs = secs % 60;
    // const hours = Math.floor(minutes / 60);
    // minutes = minutes % 60;
    return this.pad(minutes) + ':' + this.pad(secs);
  }

}






// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-video/se-video.component.ts